var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "#bbbbbb",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1.5V2.79285L4.5 4.79285V0.5H3.5V4.79285L1.5 2.79285V1.5H0.5V9.5C0.501401 10.3408 0.805265 11.153 1.35608 11.7883C1.90689 12.4236 2.66787 12.8395 3.5 12.96V15H4.5V12.96C5.33213 12.8395 6.09311 12.4236 6.64392 11.7883C7.19474 11.153 7.4986 10.3408 7.5 9.5V1.5H6.5ZM3.5 11.9494C2.93577 11.8334 2.42877 11.5265 2.06445 11.0803C1.70013 10.6341 1.50078 10.076 1.5 9.5V8.207L3.5 10.207V11.9494ZM3.5 8.79285L1.5 6.79285V4.2069L3.5 6.2069V8.79285ZM4.5 6.2069L6.5 4.2069V6.79285L4.5 8.79285V6.2069ZM4.5 11.9494V10.2069L6.5 8.2069V9.5C6.49922 10.076 6.29986 10.6341 5.93555 11.0803C5.57123 11.5265 5.06423 11.8334 4.5 11.9494Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarms);
export default __webpack_public_path__ + "static/media/farms.c785b85dbcce7a12f1ada81039e3c33f.svg";
export { ForwardRef as ReactComponent };